import Container from "@material-ui/core/Container/index";
import React from "react";


class AppPrivacyPolicy extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        window.scrollTo(0, 0)
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Container className={appStyle.privacyPolicy}>
                <Container className={appStyle.legalTextBottom}>
                    <h1>Imprint</h1> <p>
                </p> <p>
                    André Salmhofer, Vienna, Developer of Capture N' Paste and creator of the website content
                </p> <p>
                    The Capture N' Paste service aims to improve documentation efficiency by providing a mechanism to
                    put images from your phone to your workstation's clipboard in real time.
                </p>
                </Container>

                <Container className={appStyle.legalTextStandard}>
                    <h1>Impressum - Offenlegung gemäß § 25 Mediengesetz</h1> <p>
                </p> <p>
                    André Salmhofer, Wien, Entwickler von Capture N' Paste und für den Inhalt der Website verantwortlich
                </p> <p>
                    Das Capture N' Paste-Service zielt darauf ab, die Effizienz bei Dokumentationen zu erhöhen, in dem ein Mechanismus
                    angeboten wird, welcher es erlaubt, aufgenommenn Bilder und Videos von Ihrem Smartphone in die
                    Zwischenablage Ihrer Workstation zu kopieren.
                </p>
                </Container>
            </Container>
        );
    }
}

export default AppPrivacyPolicy;